import PricedropFilledCvna from '@carvana/ds-icons/PricedropFilledCvna';
import { icon } from '@carvana/ds-styles';
import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import { usePriceDrop } from '~/hooks/vdp';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { OriginalPrice, PriceWrapper, StyledPrice } from './Price.styles';

export default function PriceDrop() {
  const { finalPrice, originalPrice } = useVehiclePrice();
  const { isPriceDropRestrictedState } = usePriceDrop();
  const priceKey = useKeyWithInterval();

  return (
    <PriceWrapper>
      <div className="flex items-center gap-sm">
        <PricedropFilledCvna color={icon.success} size={16} />
        <StyledPrice key={priceKey}>
          ${formatAndDropDecimal(finalPrice)}
        </StyledPrice>
      </div>
      {!isPriceDropRestrictedState && (
        <OriginalPrice>
          was{' '}
          <span className="line-through">
            ${formatAndDropDecimal(originalPrice)}
          </span>
        </OriginalPrice>
      )}
    </PriceWrapper>
  );
}
